export default __webpack_public_path__ + "static/media/FallbackImage.3d0aa73b.jpg";